var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('profile-card'),_c('setting-list',{attrs:{"settings":_vm.settings},on:{"itemclick":_vm.onItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }